import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { systemClass } from "../../../../lib/enums";
import buildings from "../../../../assets/images/buildings/buildings";
import { Slot, SlotType, TileType } from "../../../../lib/types";
import DemolishBuildingButton from "../../../CityDialog/DemolishBuildingButton";
import backgrounds from "../../../../assets/images/buildings/backgrounds";
import {
  cancelBuildingDemolition,
  hirePop,
  openDialog,
  releasePop
} from "../../../../store/actions";
import { DragescentState } from "../../../../store/reducers/stateType";

interface IProps {
  tile: TileType;
  slot: Slot;
  slotPrices: Array<{ gold: number, bricks: number }>;
  allBuildings: SlotType[];
  freePops: number;
}

const SlotPerson = ({
  tile,
  slot,
  slotPrices,
  allBuildings,
  freePops
}: IProps) => {
  const slotType = slot.turnsToUpgrade > 0 ? slot.lowerLevelType : slot.type;
  const gold = useSelector((state: DragescentState) => state.governorate.resources.gold);
  const bricks = useSelector((state: DragescentState) => state.governorate.resources.bricks);
  const dispatch = useDispatch();
  const newBuildingRef = useRef(null);
  const actionButtonRef = useRef(null);

  return (
    <div className="col-sm-3 col-md-2" style={{ paddingLeft: "2px", paddingRight: "2px" }}>
              <span className={`person ${slotType.id ? "" : "dashed"} ${systemClass.MatchHeight}`}
                    style={{ padding: "8px" }}>
                <h3 className="h3" style={{ margin: "0 0 8px" }}>
                  {slotType.id ? slot.type.name : <>&nbsp;</>}
                </h3>
                <span className={"image"}>
                  {slotType.id === 0 && <>
                    <img
                      src={backgrounds[`background${tile.typeId}`]}
                      alt="background"
                      width={"142"}
                      height={"152"}
                      style={{ width: "100%", maxWidth: "unset", height: "auto" }}
                    />
                    <a
                      className={"btn btn-black"}
                      ref={newBuildingRef}
                      onClick={() => dispatch(openDialog({
                        slotId: slot.id,
                        name: "NewBuilding",
                        availableBuildings: tile.availableBuildings,
                        tileTypeId: tile.typeId,
                        possible: false,
                        classes: ["new-manor"],
                        slotPrices,
                        elementRef: newBuildingRef.current
                      }))}
                    >
                      {/* <span className="info"> */}
                      {/*  <i className="icon icon-dum icon-xlg middle"/> */}
                      {/* </span> */}
                      Build
                    </a>
                  </>}
                  {!!slotType.id && <img
                    src={buildings[`b${slotType.id}`]}
                    width={"142"}
                    height={"152"}
                    alt=""
                    style={{ width: "100%", maxWidth: "unset", height: "auto" }}
                  />}
                  {!slot.inDemolition && !slot.damaged && !slot.turnsToBuilt
                  && !slot.turnsToUpgrade && !!slot.upgradeBuildings.length
                  && <a
                    className={"btn btn-black"}
                    ref={actionButtonRef}
                    // onClick={() => dispatch(openTooltip({
                    //   name: "UpgradeBuilding",
                    //   dynamic: true,
                    //   classes: ["rich-tooltip"],
                    //   slot,
                    //   gold,
                    //   bricks,
                    //   slotPrices,
                    //   elementRef: actionButtonRef
                    // }))}
                    onClick={() => dispatch(openDialog({
                      name: "UpgradeBuilding",
                      classes: ["new-manor", "upgrade"],
                      slot,
                      chainBuildings: allBuildings
                        .filter(b => b.chain === slotType.chain),
                      tileTypeId: tile.typeId,
                      selectedBuilding: slotType.id,
                      gold,
                      bricks,
                      slotPrices,
                      elementRef: actionButtonRef.current
                    }))}
                  >UPGRADE</a>}
                  {!slot.inDemolition && slot.turnsToBuilt
                    ? <>
                      <div className="overlay" style={{ height: `${slot.toBuiltPercents}%` }}/>
                      <span className="progress positive" style={{ top: `${slot.toBuiltPercents}%` }}/>
                      <span className="info">
                        <strong className="number">
                          {Math.round(100 - slot.toBuiltPercents)}<span className="space"> </span>%
                        </strong>
                        <span className="text-bigger">BUILDING</span><br/>
                        Turns: {slot.turnsToBuilt}
                      </span>
                    </> : <></>
                  }
                  {slot.type.id !== 0 && !slot.inDemolition && slot.damaged && !slot.turnsToBuilt
                    ? <>
                      <div className="overlay" style={{
                        height: `${slot.repaired && slot.repairTurns
                          ? 100 * (1 - slot.turnsToRepair / slot.repairTurns) : 0}%`
                      }}/>
                      <span className="progress negative" style={{
                        top: `${slot.repaired && slot.repairTurns
                          ? 100 * (1 - slot.turnsToRepair / slot.repairTurns) : 0}%`
                      }}/>
                      <span className="info">
                        <strong className="number">
                          {Math.round(100 - slot.health * 100)}
                          <span className="space"> </span>%
                        </strong>
                        {slot.repaired
                          ? <>
                            <span className="text-bigger">REPAIRING</span><br/>
                            Turns: {slot.turnsToRepair}<br/>
                          </>
                          : <>
                            <span className="text-bigger">DAMAGED</span><br />
                            <br />
                          </>}
                      </span>
                      {!slot.repaired && <a
                        className={"btn btn-black"}
                        ref={actionButtonRef}
                        onClick={() => dispatch(openDialog({
                          name: "RepairBuilding",
                          slot,
                          gold,
                          bricks,
                          slotPrices,
                          elementRef: actionButtonRef.current
                        }))}
                      >
                        REPAIR
                      </a>}
                    </> : <></>
                  }
                  {!slot.inDemolition && !slot.damaged && slot.turnsToUpgrade
                    ? <>
                      <div className="overlay" style={{ height: `${slot.toUpgradePercents}%` }}/>
                      <span className="progress positive" style={{ top: `${slot.toUpgradePercents}%` }}/>
                      <span className="info">
                <strong className="number">
                  {100 - slot.toUpgradePercents}
                  <span className="space"> </span>%
                </strong>
                <span className="text-bigger">UPGRADE</span><br/>
                Turns: {slot.turnsToUpgrade}
              </span>
                    </> : <></>
                  }
                  {slot.inDemolition
                    ? <>
                      <div className="overlay" style={{ height: "100%" }}/>
                      <span className="progress negative" style={{ top: 0 }}/>
                      <span className="info">
                        <strong className={"number"}>
                          <i className="icon icon-md icon-zbourat"/><br/>
                        </strong>
                        <span className="text-bigger">DEMOLITION</span><br/>
                        Turns: 1
                      </span>
                      <a
                        onClick={() => dispatch(cancelBuildingDemolition(slot.id))}
                        className="btn btn-black btn-no-width"
                      >
                        Cancel
                      </a>
                    </> : <></>}
                </span>
                {<div className="text-left">
                      {slotType.popPossible > 0
                        ? Array(slot.popsLimit).fill(0)
                          .map(
                            (e: any, index: number) => (
                              (slotType.level + (slot.popsLimit - slotType.popPossible)) < index + 1 && <i key={`pop${index}`} className="icon icon-md icon-zamek disabled"/>)
                              || (slot.pops < index + 1
                                ? <a key={`pop${index}`}
                                     className={`icon icon-md icon-pop ${slot.damaged ? "disabled" : "grey"}`}
                                     onClick={() => !slot.damaged && freePops
                                       && dispatch(hirePop(slot.id))}
                                />
                                : <a key={`pop${index}`}
                                     className="icon icon-md icon-pop"
                                     onClick={() => dispatch(releasePop(slot.id))}
                                />)
                          )
                        : <i className="icon"/>}
                        {!!slotType.id
                        && <div style={{ float: "right" }}><DemolishBuildingButton slot={slot} classes={"middle icon-md"} price={slotPrices[slotType.id]}/></div>}
                    </div>
                }
              </span>
    </div>
  )
}

export default SlotPerson;
